// extracted by mini-css-extract-plugin
export default {"titR":"index_titR_4zEQl"};